<div class="message-bubble">
  <div class="message-wrapper">
    <div class="message-row">
      <div class="message-avatar">
        <img src="assets/icons/user-avatar-icon.png" alt="user-icon" width="50" height="50" />
      </div>
      <div class="message-content">
        @if (displayedContent !== '') {
          <div #messageContent
            class="custom-content math-larger"
            [innerHTML]="displayedContent.trim() | safeHtml">
          </div>
        }

        @if (message.isOffline) {
          <button class="retry-button" (click)="retryMessage(message)" title="Retry" [ngClass]="{ blinking: isBlinking }">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="red"
              stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="margin-right: 8px">
              <polyline points="23 4 23 10 17 10"></polyline>
              <polyline points="1 20 1 14 7 14"></polyline>
              <path d="M3.51 9a9 9 0 0114.13-3.36L23 10M1 14l5.36 5.36A9 9 0 0020.49 15"></path>
            </svg>
            <span class="retry-text">Unable to send your message, try again later.</span>
          </button>
        }
      </div>

      @if (!isEditingMessage) {
        <button class="edit-button" title="Edit" (click)="editMessage(message)">
          <img src="assets/icons/edit-icon.png" alt="Edit Button" width="18" height="18" />
        </button>
      }
    </div>
  </div>
</div>
